import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 13rem;
    height: 2.125rem;

    svg {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 2rem;
  background: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
